import * as S from "./EventDetailPlaceholder.style";

const EventDetailPlaceholder = () => {
  return (
    <S.Container>
      <S.ImageWrapper>
        <S.ImagePlaceholder />
        <S.DotsList>
          <li />
          <li />
          <li />
          <li />
          <li />
        </S.DotsList>
      </S.ImageWrapper>

      <S.ContentWrapper>
        <S.TitleSkeleton />
        <S.ContentSkeleton />
        <S.ContentSkeleton />
      </S.ContentWrapper>
    </S.Container>
  );
};

export default EventDetailPlaceholder;
